@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../host-display-block' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	.kol-tabs {
		display: var(--display);
		grid-template-columns: var(--grid-template-columns);
		grid-template-rows: var(--grid-template-rows);

		&--align-right {
			--display: grid;
			--grid-template-columns: 1fr auto;

			--button-group-flex-direction: column;
			--button-group-order: 2;
		}

		&--align-left {
			--display: grid;
			--grid-template-columns: auto 1fr;

			--button-group-flex-direction: column;
			--button-group-order: 0;
		}

		&--align-bottom {
			--display: grid;
			--grid-template-rows: 1fr auto;

			--button-group-order: 2;
		}

		&__tabs-align-top {
			--display: grid;
			--grid-template-rows: auto 1fr;

			--button-group-order: 0;
		}

		&__button-group {
			display: flex;
			order: var(--button-group-order);

			flex-direction: var(--button-group-flex-direction);
			flex-wrap: wrap;

			.kol-button {
				border-bottom-color: transparent;
				display: block;
				border-bottom-style: solid;
			}
		}

		&__panel {
			height: 100%;
		}
	}
}
